import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { verifyResetToken, updatePassword } from '../interfaces/authInterface';
// If using react-router-dom to get URL token:
import { useParams, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { token, email } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      verifyResetToken({ email: email,token: token })
        .then(() => {
          message.success('Token is valid. You can now reset your password.');
          // Pre-fill the token and email in the form
          form.setFieldsValue({ email: email || '' });
        })
        .catch((error) => {
          message.error(error.response?.data?.error || 'Invalid or expired token.');
        });
    }
  }, [token, form]);

  const onFinish = async (values) => {
    setLoading(true);


    // 1. Extract the required parameters
    const { email, newPassword } = values;

    try {
      // 2. ⚠️ REPLACE THIS WITH YOUR ACTUAL API CALL
      // Example: await axios.post('/api/reset-password-final', { email, token, newPassword });
      updatePassword({ email, newPassword, token });
      await new Promise(resolve => setTimeout(resolve, 2000)); // Simulate API delay

      message.success('Your password has been successfully reset! You can now log in.');
      // 3. Optional: Redirect to login page
      navigate('/login');

    } catch (error) {
      message.error(error.response?.data?.error || 'Password reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Card title="🔐 Set Your New Password" style={{ width: 400 }}>
        <Form
          form={form}
          name="reset_password"
          onFinish={onFinish}
          layout="vertical"
          initialValues={{
            // Pre-fill email and token here if they are known (e.g., from the URL or state)
            // email: 'user@example.com',
            // token: urlToken || '',
          }}
        >
          {/* Email/Username Input (Required Parameter) */}
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'The input is not a valid E-mail!' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Enter your registered email" />
          </Form.Item>

          {/* New Password Input */}
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[{ required: true, message: 'Please input your new Password!' }]}
            hasFeedback
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Enter new password" />
          </Form.Item>

          {/* Confirm New Password Input */}
          <Form.Item
            label="Confirm New Password"
            name="confirm"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              { required: true, message: 'Please confirm your new Password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Confirm new password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading} ghost>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPassword;
